export enum PRODUCT_TYPE {
  UNKNOWN = 0,
  LECTIO,
  TEA,
}

export enum CONTACT_TYPE {
  LECTIO = 1,
  TEA,
  MATERIAL,
  IT,
  TOUR,
}

export enum MODULE_STATUS_TYPE {
  UNKNOWN = 0,
  UNSUBMITTED,
  TO_BE_REVIEWED,
  DONE,
}

export enum STATUS_TYPE {
  UNKNOWN = 0,
  IN_PROCESS,
  DONE,
  CANCEL,
}

export enum SHEET_MODULES {
  ATLASTENANT = 'atlasTenant',
  LECTIOLESSONSELECT = 'lectioLessonSelect',
  ATLASTEACHER = 'atlasTeacher',
  ATLASMCLASS = 'atlasMclass',
  LECTIOSCHEDULE = 'lectioSchedule',
  ATLASSTUDENT = 'atlasStudent',
  ATLASCOURSE = 'atlasCourse',
  LECTIOLESSONSELECTANDATLASTENANT = 'lessonSelectAndAtlasTenant',
  ATLASMCLASSANDLECTIOSCHEDULE = 'atlasMclassAndlectioSchedule',
}

export const SHEET_MODULES_CN = {
  [SHEET_MODULES.ATLASTENANT]: '学校基础信息',
  [SHEET_MODULES.LECTIOLESSONSELECT]: '选课',
  [SHEET_MODULES.ATLASTEACHER]: '教师账号申请',
  [SHEET_MODULES.ATLASMCLASS]: '班级信息',
  [SHEET_MODULES.LECTIOSCHEDULE]: '排课',
  [SHEET_MODULES.ATLASSTUDENT]: '学生信息',
  [SHEET_MODULES.ATLASCOURSE]: '任教安排',
  [SHEET_MODULES.LECTIOLESSONSELECTANDATLASTENANT]: '选课',
  [SHEET_MODULES.ATLASMCLASSANDLECTIOSCHEDULE]: '排课',
}

export const SHEET_MODULES_DESCRIPTION = {
  [SHEET_MODULES.LECTIOLESSONSELECTANDATLASTENANT]: '选课并填写学具随材收货地址',
  [SHEET_MODULES.ATLASTEACHER]: '为学校老师申请账号权限',
  [SHEET_MODULES.ATLASMCLASS]: '班级信息',
  [SHEET_MODULES.LECTIOSCHEDULE]: '排课',
  [SHEET_MODULES.ATLASSTUDENT]: '学生信息',
  [SHEET_MODULES.ATLASCOURSE]: '任教安排',
  [SHEET_MODULES.ATLASMCLASSANDLECTIOSCHEDULE]: '创建班级并排课',
}
